import React, { lazy, useEffect, Suspense, useRef } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";

import initializeApp from "./app/init";
// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));

initializeApp();

// Force dark theme logic...
if (
  !localStorage.getItem("theme") ||
  localStorage.getItem("theme") === "light"
) {
  localStorage.setItem("theme", "dark");
}
document.documentElement.setAttribute("data-theme", "dark");

function App() {
  // Use refs to avoid re-creating audios objects on every render
  const hoverSound = useRef(new Audio("/music.mp3"));
  // const clickSound = useRef(new Audio("/music.mp3"));

  useEffect(() => {
    // 1. Theme initialization
    if (!localStorage.getItem("theme")) {
      localStorage.setItem("theme", "dark");
    }
    document.documentElement.setAttribute(
      "data-theme",
      localStorage.getItem("theme") || "dark",
    );
    themeChange(false);

    // 2. Global Sound Logic
    // const handleGlobalClick = () => {
    //   clickSound.current.currentTime = 0;
    //   clickSound.current.play().catch(() => {}); // Catch prevents errors if browser blocks audio
    // };

    const handleGlobalHover = (e) => {
      // Trigger sound only if hovering over interactive elements
      const isInteractive = e.target.closest(
        "button, a, [role='button'], input, .btn",
      );

      if (isInteractive) {
        hoverSound.current.volume = 0.2; // Keep hover subtle
        hoverSound.current.currentTime = 0;
        hoverSound.current.play().catch(() => {});
      }
    };

    // window.addEventListener("mousedown", handleGlobalClick);
    window.addEventListener("mouseover", handleGlobalHover);

    return () => {
      // window.removeEventListener("mousedown", handleGlobalClick);
      window.removeEventListener("mouseover", handleGlobalHover);
    };
  }, []);

  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={
              /* your existing loading styles */ {
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#0a1628",
              }
            }
          >
            <p style={{ color: "#00cc8e" }}>Loading...</p>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/app/*" element={<Layout />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
